export default __webpack_public_path__ + "static/media/pw-manage-table.794ac66a.jpg";